import {combineReducers} from "redux"
import auth from "./auth"
import message from "./message"
import modals from "./modal"

export default combineReducers({
    auth,
    message,
    modals
})